



























































import { Component, Mixins, Prop } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { Questionnaire, QuestionnaireDetails } from "~/contractinfo.type";
import { translate } from "@/utils";

@Component({})
export default class QuestionDet extends Mixins(FormValidator) {
  @Prop()
  private question: Questionnaire;

  get qn() {
    return this.question;
  }

  get qnt() {
    return translate(this.question);
  }

  get isSelectorRating() {
    return this.question.rqd.find(x => x.selector_type === 3) != null;
  }

  getLabel(var_rid: number) {
    return this.qnt.rqd.find(
      (x: QuestionnaireDetails) => x.var_rid === var_rid,
    );
  }

  validate() {
    if (!this.qn.is_required) return true;
    const r = this.qn.rqd.find(
      (x: QuestionnaireDetails) =>
        (x.selector_type === 0 && x.checked) ||
        (x.selector_type === 1 && x.text && x.text !== "") ||
        (x.selector_type === 3 && x.text && x.text !== ""),
    );
    if (r) {
      //this.$emit("resetValidation");
      return true;
    }
    return this.$t("form-validator.required");
  }
}
